var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid monarch-home-view"},[_c('vml-home-intro-component'),_c('vml-home-about-monarch-component'),_c('vml-home-news-component'),_c('disease-carousel'),_c('vml-home-partners-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }